<template>
    <div class="print-container">
        <div class="header">
            <div class="logo">
                <img src="../../../public/progress.jpg" alt="Şirkət Loqosu" />
            </div>
            <div class="company-info">
                <p>{{ companyName }}</p>
                <p>{{ companyAddress }}</p>
                <p><strong>Tel:</strong> {{ companyPhone }}</p>
                <p><strong>Email:</strong> {{ companyEmail }}</p>
            </div>
        </div>

        <div class="section">
            <p><strong>Tarix:</strong> {{ date }}</p>
            <p><strong>Məktub №:</strong> {{ letterNumber }}</p>
        </div>

        <div class="section">
            <p><strong>Qarşı Tərəf:</strong> {{ recipientName }}</p>
            <p><strong>Ünvan:</strong> {{ recipientAddress }}</p>
        </div>

        <div class="section">
            <p><strong>Mövzu:</strong> Subroqasiya əsasında ödənilmiş zərərin əvəzinin tələb olunması haqqında</p>
        </div>

        <div class="section body-text">
            <p>Hörmətli {{ recipientContact }},</p>

            <p>{{ eventDate }} tarixində {{ eventPlaceReason }} ilə bağlı sığortalımız {{ insuredName }} zərərə məruz
                qalmışdır. Araşdırma nəticəsində məlum olmuşdur ki, hadisənin baş verməsində sizin məsuliyyətiniz
                müəyyən edilmişdir.</p>

            <p>Sığortalı ilə bağlanmış {{ policyNumber }} əsasında sığorta şirkətimiz tərəfindən {{ paymentAmount }}
                manat məbləğində sığorta ödənişi həyata keçirilmişdir.</p>

            <p>Azərbaycan Respublikasının Mülki Məcəlləsinin 949-cu maddəsinə əsasən, sığortaçı ödəniş etdiyi məbləğ
                həddində üçüncü şəxsə qarşı iddia qaldırmaq hüququna malikdir.</p>

            <p>Bununla əlaqədar, sizdən {{ paymentDate }} tarixində ödənilmiş {{ paymentAmount }} manat məbləğində
                zərərin könüllü şəkildə 3 iş günü ərzində aşağıdakı bank hesabımıza ödənilməsini tələb edirik:</p>

            <div class="bank-info">
                <p><strong>Bankın adı:</strong> {{ bankName }}</p>
                <p><strong>Hesab nömrəsi:</strong> {{ accountNumber }}</p>
                <p><strong>VÖEN:</strong> {{ voen }}</p>
                <p><strong>SWIFT:</strong> {{ swiftCode }}</p>
            </div>

            <p>Əks təqdirdə, qanunvericiliyə uyğun olaraq hüquqlarımızın müdafiəsi məqsədilə məhkəməyə müraciət
                edəcəyimizi və əlavə xərclərin də sizdən tələb olunacağını bildiririk.</p>

            <p>Əməkdaşlıq edəcəyinizə ümid edirik.</p>
        </div>

        <div class="signature">
            <p>Hörmətlə,</p>
            <p>{{ responsibleName }}</p>
            <p>Vəzifə: {{ responsiblePosition }}</p>
            <p>{{ companyName }}</p>
        </div>
    </div>
</template>

<script>
import { GetPreCourtLetter } from '@/project/Source/courtpreparations';

export default {
    props: {
        subrogationId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            companyLogo: '/logo.png',
            companyName: 'HU Estimates MMC',
            companyAddress: 'Bakı şəhəri, Nərimanov rayonu, XYZ küçəsi 10',
            companyPhone: '+994 12 123 45 67',
            companyEmail: 'info@example.com',
            date: '',
            letterNumber: '',
            recipientName: '',
            recipientAddress: '',
            recipientContact: '',
            eventDate: '',
            eventPlaceReason: '',
            insuredName: '',
            policyNumber: '',
            paymentAmount: '',
            paymentDate: '',
            paymentDeadline: '',
            bankName: '',
            accountNumber: '',
            voen: '',
            swiftCode: '',
            responsibleName: '',
            responsiblePosition: ''
        };
    },
    async mounted() {
        await this.loadPreCourtLetterData();
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return '-';
            const d = new Date(dateStr);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}.${mm}.${yyyy}`;
        },
        async loadPreCourtLetterData() {
            try {
                const response = await GetPreCourtLetter(this.subrogationId);
                const d = response.data.data[0];

                this.date = this.formatDate(d.letterDate);
                this.letterNumber = '№' + d.id;
                this.recipientName = d.tortfeasor;
                this.recipientAddress = d.tortfeasorPlace;
                this.recipientContact = d.tortfeasor;
                this.eventDate = this.formatDate(d.incidentDate);
                this.eventPlaceReason = d.incidentPlace && d.incidentCause
                    ? d.incidentPlace + ' - ' + d.incidentCause
                    : d.incidentPlace || '';
                this.insuredName = d.insuredName;
                this.policyNumber = d.policyNumber;
                this.paymentAmount = d.paidAmount;
                this.paymentDate = this.formatDate(d.companyPaymentDate);
                this.bankName = d.bankName;
                this.accountNumber = d.accountNumber;
                this.voen = d.taxId;
                this.swiftCode = d.swift;
                this.responsibleName = d.signatoryName;
                this.responsiblePosition = d.signatoryPosition;
                this.companyName = d.signerCompanyName;

            } catch (err) {
                console.error('❌ Error loading PreCourtLetter:', err);
            }
        }
    }
}
</script>

<style scoped>
@media print {
    body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
}

p {
    margin-bottom: 8px
}

.print-container {
    margin: 0 20px;
    font-family: Arial, sans-serif;
    font-size: 13px;
    line-height: 1;
    color: #000;
    box-sizing: border-box;
    background: #fff;
}

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.logo img {
    height: 60px;
    object-fit: contain;
}

.company-info {
    text-align: right;
    font-size: 12.5px;
}

.bank-info {
    margin: 15px 0 25px 0;
    padding-left: 10px;
}

.signature {
    margin-top: 20px;
}
</style>
